import { Button, Card, Col, Divider, Flex, Input, Modal, Row, Switch, Table } from 'antd'
import React, { useState, useEffect } from 'react'
import { SearchOutlined, StarFilled } from '@ant-design/icons';
import { userState } from '../../service/database'
import { useRecoilState } from 'recoil'
import { titleize } from '../../service/util';
import api from '../../service/axios'
import { useToasts } from 'react-toast-notifications';
import { array } from 'firebase/firestore/pipelines';




export const EncontreProfissional = (props) => {

    const [user,] = useRecoilState(userState)
    const [data, setData] = useState(undefined)
    const [loading, setLoading] = useState(false)
    const { addToast } = useToasts()
    const [selected, setSelected] = useState({})
    const [open, setOpen] = useState(false)


    useEffect(() => {
        console.log(user)
        load()
    }, [])

    async function load() {
        try {
            setLoading(true)
            const result = await api.get('/api/v1.0/registrado/taleto'.concat(user?.isprofissional === 1 ? '' : 's'), {
                headers: {
                    'x-access-token': user?.token2
                }
            })
            setData(result.data)
            console.log(result.data)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }

        setLoading(false)

    }

    async function salve() {
        try {
            setLoading(true)

            let result = await api.post('/api/v1.0/registrado/taleto', data, {
                headers: {
                    'x-access-token': user?.token2
                }
            })
            // setData(result.data)
            addToast("Dados atualizados com sucesso!", { appearance: 'success', autoDismiss: true })
            console.log(result.data)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }

        setLoading(false)

    }

    if (user?.isprofissional === 1) {
        return <Flex vertical gap={20}>
            <Flex gap={5}><StarFilled style={{ color: 'gold' }} /><b>BANCO DE TALENTOS CRQ10/CE</b></Flex>
            <Flex style={{ textAlign: 'justify' }}>
                Conecte seu talento às melhores oportunidades da área da Química.
            </Flex>

            <div style={{ textAlign: 'justify' }}>
                O <b>Banco de Talentos do CRQ10</b> reúne profissionais regularmente registrados que desejam aumentar sua
                visibilidade no mercado de trabalho. Ao cadastrar seu perfil, ele poderá ser consultado por empresas e instituições em busca de profissionais qualificados.
            </div>

            <div>
                Mantenha suas informações sempre atualizadas e esteja preparado para novas oportunidades.
            </div>

            <Card
                title={"Dados a serem compartilhados com as empresas"}>
                <Row gutter={[8, 8]}>
                    <Col xs={24} md={2}><b>Nome:</b></Col>
                    <Col xs={24} md={22}>{titleize(user?.nome)}</Col>
                    <Col xs={24} md={2}><b>Telefone:</b></Col>
                    <Col xs={24} md={22}>{user?.telefone}</Col>
                    <Col xs={24} md={2}><b>Categoria:</b></Col>
                    <Col xs={24} md={22}>{titleize(user?.categoria)}</Col>
                    <Col xs={24} md={2}><b>E-mail:</b></Col>
                    <Col xs={24} md={22}>{user?.emailprimary}</Col>
                    <Col xs={24} md={2}><b>Cidade:</b></Col>
                    <Col xs={24} md={22}>{titleize(user?.cidade)}</Col>
                    <Col span={24}><b>Fale sobre você</b></Col>
                    <Col span={24}>
                        <Input.TextArea
                            placeholder='Descreva seu perfil profissional, experiências, habilidades e áreas de interesse'
                            showCount
                            maxLength={500}
                            value={data?.sobre}
                            onChange={(e) => {
                                setData({ ...data, sobre: e.target.value })
                            }} />

                    </Col>
                </Row>
            </Card>

            <div>
                O CRQ-10 atua exclusivamente como facilitador da divulgação dos perfis cadastrados, não participando dos processos seletivos,
                das contratações ou das negociações entre candidatos e empresas. A responsabilidade pela seleção e contratação é integralmente das
                empresas, assim como a veracidade das informações cadastradas é de responsabilidade do profissional.
            </div>

            <Flex vertical gap={30}>
                <Flex gap={10} align='center'>
                    <b>Autorizo o compartilhamento dos meus dados</b>
                    <Switch
                        checked={data?.autorizo}
                        onChange={(e) => {
                            setData({ ...data, autorizo: e })
                        }} />
                </Flex>

                <Flex>
                    <Button loading={loading} style={{ width: 80 }} type='primary' onClick={() => salve()}>Salvar </Button>
                </Flex>
            </Flex>
        </Flex>
    } else {
        return <Flex vertical gap={20}>
            <Flex gap={5}><StarFilled style={{ color: 'gold' }} /><b>BANCO DE TALENTOS CRQ10/CE</b></Flex>
            {Array.isArray(data) && <Table loading={loading} dataSource={data} bordered size='small' pagination={false}
                title={() => <Flex>Registros encontrados: {data.length}</Flex>}>
                <Table.Column title={"Nome"} render={(txt, item, index) => {
                    return titleize(item.nome)
                }} />

                <Table.Column title={"Categoria"} render={(txt, item, index) => {
                    return titleize(item.categoria)
                }} />
                <Table.Column title={"Celular"} render={(txt, item, index) => {
                    return item.celular
                }} />
                <Table.Column title={"E-mail"} render={(txt, item, index) => {
                    return item.emailprimary
                }} />
                <Table.Column title={"Cidade"} render={(txt, item, index) => {
                    return titleize(item.cidade)
                }} />
                <Table.Column title={""} width={60} align='center' render={(txt, item, index) => {
                    return <Button size='small' icon={<SearchOutlined />} type='link' onClick={() => {
                        setSelected(item)
                        setOpen(true)
                    }}></Button>
                }} />
            </Table>
            }


            <Modal
                centered
                title={"Talentos CRQ10/CE - ".concat(selected?.nome)}
                onCancel={() => setOpen(false)}
                closable={true}
                open={open}
                footer={() => <Flex justify='flex-end'>
                    <Button onClick={() => setOpen(false)}>Fechar</Button>
                </Flex>}>
                <Card>
                    <Flex vertical gap={5}>
                        <Flex gap={5}>
                            <b>Nome:</b> {titleize(selected?.nome)}
                        </Flex>
                        <Divider style={{ marginTop: 3, marginBottom: 3 }} />
                        <Flex gap={5}>
                            <b>Categoria:</b> {titleize(selected?.categoria)}
                        </Flex>
                        <Divider style={{ marginTop: 3, marginBottom: 3 }} />
                        <Flex gap={5}>
                            <b>Telefone:</b> {selected?.celular}
                        </Flex>

                        <Divider style={{ marginTop: 3, marginBottom: 3 }} />
                        <Flex gap={5}><b>E-mail:</b> {selected?.emailprimary}</Flex>
                        <Divider style={{ marginTop: 3, marginBottom: 3 }} />
                        <Flex gap={5}><b>Cidade:</b> {titleize(selected?.cidade)}</Flex>
                        <Divider style={{ marginTop: 3, marginBottom: 3 }} />
                        <Flex vertical>
                            <Flex><b>Descrição do Profissional</b></Flex>
                            <Flex>{selected?.sobre}</Flex>
                        </Flex>
                    </Flex>
                </Card>
            </Modal>

        </Flex>

    }
}


export default EncontreProfissional